import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id BEDFC0D3-5AC2-46E4-BD69-07048CC47710
 * name syllabary-katakana-halfwidth
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/syllabary-katakana-halfwidth.svg
 * tags
 * - Alpha / Numeric 
 */
export const SyllabaryKatakanaHalfwidthIcon = createSvgIcon(<><path d="M8 4V6H14L13 10.81L15 11.2L16 6.1V4M10 9V12C10 14.86 9.34 17.29 8.08 18.61L9.5 20C11.35 18.08 12 15.15 12 12V9Z" /></>, 'SyllabaryKatakanaHalfwidthIcon');
export default SyllabaryKatakanaHalfwidthIcon